"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components");const r=(r="30px")=>e.css`
    > :not([hidden]):not(:empty) ~ :not([hidden]):not(:empty) {
        margin-top: ${r};
    }
`;var o=e.css`
    padding: 0 ${({theme:e})=>e.spacing.large} 55px;
    border-bottom: solid 1px ${({theme:e})=>e.colors.grey[300]};
    ${r()}

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        padding: 51px ${({theme:e})=>e.spacing.large} 0;
        border-bottom: none;
    }

    header {
        > * {
            margin: 0;
        }
    }

    .details {
        display: grid;
        grid-template-columns: repeat(2, auto);
        grid-column-gap: 15px;
        grid-row-gap: 15px;
    }

    .detail {
        p {
            margin: 0;
        }

        svg {
            width: 21px;
            height: auto;
        }
    }

    .price {
        background: ${({theme:e})=>e.colors.grey[50]};
        border-radius: 3px;
        padding: 20px;

        header {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            h2 {
                margin: 0 7px 5px 0;
            }

            p {
                margin: 0 2px 0 0;
            }

            .zipcode_selector {
                > p {
                    display: none;
                }

                > button {
                    margin: 0;
                    padding: 0;
                    border: none;
                }
            }
        }

        h3 {
            margin: 0;

            svg {
                margin-left: 5px;
            }
        }

        a {
            display: block;
            color: ${({theme:e})=>e.colors.primary.default};
            text-decoration: underline;
            cursor: pointer;
            margin-top: 7px;
        }
    }

    .out-of-service-area {
        padding: 20px;
        background: ${({theme:e})=>e.colors.grey[200]};
        border-radius: 3px;

        p {
            margin: 0;

            svg {
                vertical-align: middle;
            }
        }

        .learn-more {
            a {
                color: ${({theme:e})=>e.colors.primary.dark};
            }
        }
    }

    > p {
        margin-bottom: 31px;
    }
    .DXHomeOverview-CallToAction {
        ${r()}
        .DXLinkArrow {
            font-size: 12px;
        }
    }
`;exports.addChildVerticalSpace=r,exports.default=o;
//# sourceMappingURL=stylesOverview.js.map
